module.exports = __webpack_public_path__ + "static/media/julian_birkett.42c079a5.jpeg";